<template>
  <div class="datePicker datePickerHis">
    <van-field
      readonly
      clickable
      name="datetimePicker"
      :value="`${currentDate} ${currentWeek}`"
      label=""
      placeholder="点击选择时间"
      @click="showCalendar = true"
    />
    <van-popup
      v-model="showCalendar"
      position="bottom"
    >
      <van-datetime-picker
        type="datehour"
        ref="datehourPicker"
        title="选择日期时间段"
        placeholder="选择日期"
        :min-date="dateForm.minDate"
        :max-date="dateForm.maxDate"
        :min-hour="dateForm.minHour"
        :max-hour="dateForm.maxHour"
        :format="dateForm.dateFormat"
        :filter="dateFilter"
        style="width: 100%;"
        @confirm="timeConfirm"
      ></van-datetime-picker>
    </van-popup>

  </div>
</template>

<script>
import mixins from "./mixins";
import { isPhone } from "@/utils/utils";
import moment from "moment";
import { Message } from "element-ui";

const endTips = "今日已约完";

const weekList = ["日", "一", "二", "三", "四", "五", "六"];

export default {
  name: "dateTimePickerHis",
  mixins: [mixins],
  data() {
    return {
      showCalendar: false,
      form: {},
      isPhone: isPhone(),
      currentDate: "",
      currentWeek: "",
      tempTime: "",
      dateForm: {
        minDate: moment().add(1, "hour").toDate(),
        maxDate: new Date(new Date().getFullYear() + 1, 11, 31),
        dateFormat: "YYYY-MM-DD HH:mm",
        minHour: 8,
        maxHour: 17,
        minMinute: 0,
        maxMinute: 30,
      },
    };
  },
  created() {
    console.log();
  },
  methods: {
    moment,
    timeConfirm(value) {
      const picker = this.$refs.datehourPicker.getPicker();
      if (picker.getColumnValue(3) === endTips) {
        Message({
          message: `请选择预约时段`,
          type: "warning",
        });
        return;
      }

      this.currentDate = `${moment(value).format(
        "YYYY-MM-DD"
      )} ${picker.getColumnValue(3)}`;
      this.currentWeek = `星期${weekList[moment(value).day()]}`;
      this.change(this.currentDate);
      this.showCalendar = false;
    },

    dateFilter(type, options) {
      const { dateForm } = this;
      if (type === "hour") {
        const newOptions = [];
        options.forEach((item) => {
          if (item < dateForm.minHour || item > dateForm.maxHour) {
            return;
          } else {
            newOptions.push(`${item}:00-${item}:30`);
            newOptions.push(`${item}:30-${Number(item) + 1}:00`);
          }
        });
        options = newOptions;
      }
      if (type === "hour" && options.length === 0) {
        options.push(endTips);
      }
      return options;
    },
  },
};
</script>

<style lang="scss" scoped>
.van-cell {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style>
<style lang="scss">
.datePickerHis .van-picker__columns .van-picker-column:nth-child(4) {
  flex: 2;
}
</style>